type Point = { x: number; y: number; z: number };
type Row = Record<string, unknown>;
const record = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;

/** An unheld breach overlay matters only where the body can touch the drawn wall's slab. */
export function sceneWallNearBody(value: unknown, point: Point, radius: number, height: number): boolean {
  const wall = record(value);
  if (!wall) return false;
  const span = record(wall.span), z = record(wall.z);
  if (!span || !z || !['x', 'y'].includes(String(wall.axis))) return true;
  if (point.z + height < Number(z.min) || point.z > Number(z.max)) return false;
  const normal = wall.axis === 'x' ? point.x : point.y, along = wall.axis === 'x' ? point.y : point.x;
  return Math.hypot(Math.max(0, Math.abs(normal - Number(wall.at)) - Math.max(0.05, Number(wall.thicknessFt ?? 0.5)) / 2),
    Math.max(0, Number(span.min) - along, along - Number(span.max))) <= radius + 0.5;
}
